import { useState } from 'react'
import { useNavigate, Link, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '../../contexts/authStore'
import { authAPI } from '../../services/api'

import { logger } from '@/utils/logger';
export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [rememberMe, setRememberMe] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const setAuth = useAuthStore((state) => state.setAuth)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      const response = await authAPI.login(email, password, rememberMe)
      const { email: userEmail, user_type } = response.data

      // Set auth state (cookie is already set by backend)
      setAuth(userEmail, user_type)

      // Check for return URL
      const returnUrl = searchParams.get('return')

      if (returnUrl) {
        // Decode and navigate to return URL
        navigate(decodeURIComponent(returnUrl))
      } else {
        // Default: Redirect to appropriate dashboard
        navigate(user_type === 'admin' ? '/admin' : '/customer')
      }
    } catch (err) {
      setError('Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre E-Mail und Ihr Passwort.')
      logger.error('Login error:', err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="wc-container" style={{ padding: '72px 32px' }}>
      <div style={{ maxWidth: 420, margin: '0 auto' }}>
        <div className="wc-card wc-elev-sm" style={{ padding: 28, gap: 20 }}>
          <div>
            <p className="wc-kicker" style={{ marginBottom: 6 }}>Portal</p>
            <h1 style={{ fontSize: 30, margin: 0 }}>Anmelden</h1>
          </div>

          {searchParams.get('return') && (
            <div className="wc-alert wc-alert-info" role="status">
              <strong>Session abgelaufen.</strong> Bitte melden Sie sich erneut an.
            </div>
          )}

          {error && (
            <div className="wc-alert wc-alert-error" role="alert">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} style={{ display: 'grid', gap: 16 }}>
            <div className="wc-field">
              <label htmlFor="email">E-Mail</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="wc-input"
                required
                autoComplete="email"
              />
            </div>

            <div className="wc-field">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'baseline',
                  justifyContent: 'space-between',
                  gap: 12,
                }}
              >
                <label htmlFor="password">Passwort</label>
                <Link to="/forgot-password" style={{ fontSize: 12 }}>
                  Passwort vergessen?
                </Link>
              </div>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="wc-input"
                required
                autoComplete="current-password"
              />
            </div>

            <label className="wc-check" htmlFor="rememberMe">
              <input
                type="checkbox"
                id="rememberMe"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              Angemeldet bleiben (30 Tage)
            </label>

            <button
              type="submit"
              disabled={loading}
              className="wc-btn wc-btn-primary wc-btn-block"
            >
              {loading ? 'Anmelden…' : 'Anmelden'}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}
